import { WorldTourSwissRecord as WtSwissRecord } from "model/Records old/WorldTourSwissRecord";
import { selectRosterDisplayName } from "selectors/Roster";
import {
  DifferentialCell,
  OrgLogoContainer,
  PositionCell,
  RecordCell,
  TeamLogoCell,
  TeamNameCell,
  WinLossRecordCell,
} from "../styles";
import { MatchPlaceHolderCell, SwissTeamRow } from "../styles";
import { SwissTableMatchResult } from "./SwissTableMatchResult";
import { Match } from "model/Match/Match";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { JSX } from "react";
import { useAppSelector } from "app/hooks";

interface Props {
  record: WtSwissRecord;
  tournamentId: string;
  numberOfRounds: number;
}

export const SwissTableRow = ({
  record,
  tournamentId,
  numberOfRounds,
}: Props) => {
  const orgName = useAppSelector((state) =>
    selectRosterDisplayName(state, record.rosterId, tournamentId)
  );
  const trackDifferential = record.tracksWon - record.tracksLost;

  return (
    <SwissTeamRow>
      <PositionCell>{record.position}.</PositionCell>
      <TeamLogoCell>
        <OrgLogoContainer>
          <RosterOrgLogo
            rosterId={record.rosterId}
            tournamentId={tournamentId}
          />
        </OrgLogoContainer>
      </TeamLogoCell>
      <TeamNameCell>{orgName}</TeamNameCell>
      <WinLossRecordCell>
        {record.wins} - {record.loses}
      </WinLossRecordCell>
      <RecordCell>
        {record.tracksWon} - {record.tracksLost}
      </RecordCell>
      <DifferentialCell>
        {trackDifferential > 0 ? "+" : ""}
        {trackDifferential}
      </DifferentialCell>
      <>
        {getRoundCells(
          record.rosterId,
          tournamentId,
          record.matches,
          numberOfRounds
        )}
      </>
    </SwissTeamRow>
  );
};

const getRoundCells = (
  rosterId: string,
  tournamentId: string,
  matches: (Match | undefined)[],
  numberOfRounds: number
) => {
  const cells: JSX.Element[] = [];
  matches.forEach((m) => {
    if (!m) {
      cells.push(<MatchPlaceHolderCell />);
    } else {
      cells.push(
        <SwissTableMatchResult
          match={m}
          rosterId={rosterId}
          tournamentId={tournamentId}
        />
      );
    }
  });

  while (cells.length < numberOfRounds) {
    cells.push(<MatchPlaceHolderCell />);
  }

  return cells;
};
